import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import AdminPage from "../AdminPage";
import UserDataAdmin from "../UserDataAdmin/UserDataAdmin";
import { SERVERURL } from "../../../ServerUrl";

const COPY = {
  title: "Users",
  subtitle: "You Can See Detail About Users",
  searchPlaceholder: "Search User",
};

const UserAdmin = () => {
  const [searchValue, setSearchValue] = useState("");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${SERVERURL}/api/v1/getUsers`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data) {
          setUsers(response.data);
        } else {
          Swal.fire("", response.data.error, "error");
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const visibleUsers = users.filter((user) =>
    (user.fullName || "").toLowerCase().includes(searchValue.toLowerCase())
  );

  return (
    <AdminPage
      title={COPY.title}
      subtitle={COPY.subtitle}
      loading={loading}
      search={{
        value: searchValue,
        onChange: setSearchValue,
        placeholder: COPY.searchPlaceholder,
      }}
    >
      <UserDataAdmin driverData={visibleUsers} />
    </AdminPage>
  );
};

export default UserAdmin;
